<template>
  <main class="p-3">
    <label for="name" class="font-bold"
      >Гарчиг /монголоор/:<span class="text-red-500">*</span></label
    >
    <input
      type="text"
      placeholder="Гарчиг"
      class="w-full border rounded p-2 mb-5"
      v-model="form.title"
    />

    <label for="name" class="font-bold">Гарчиг /англиар/:</label>
    <input
      type="text"
      placeholder="Гарчиг"
      class="w-full border rounded p-2 mb-5"
      v-model="form.title_en"
    />

    <label for="image" class="font-bold"
      >Нүүр зураг<span class="text-red-500">*</span></label
    >
    <div class="space-y-3 w-full mb-5">
      <div
        class="flex flex-col justify-center items-center w-full"
        :class="mainImage ? 'w-3/4' : 'h-40 w-40'"
      >
        <img
          :src="imageSrc"
          alt="image"
          :class="!mainImage ? 'w-14 h-14' : 'w-40 object-fit'"
        />
        <span v-if="!mainImage" class="text-xs text-gray-500"
          >Зураг байхгүй байна</span
        >
      </div>

      <div class="flex gap-4">
        <img
          v-if="previousImage"
          :src="previousImage"
          @click="selectDefaultImage(previousImage)"
          class="w-16 h-16 cursor-pointer border rounded hover:ring-2 hover:ring-blue-400"
          :class="{
            'ring-2 ring-blue-500': imageSrc === previousImage,
          }"
          alt="Female"
        />
      </div>

      <input
        id="image"
        name="image"
        type="file"
        class="w-full border border-gray-300 rounded p-2"
        @change="onImageChange"
        accept="image/jpeg, image/png"
      />
      <span class="text-sky-500 text-xs">
        Зөвхөн jpg, jpeg, png өргөтгөлтэй зураг оруулна уу.
      </span>
    </div>

    <label for="pdf" class="font-bold"
      >Файл:<span class="text-red-500">*</span></label
    >
    <div>
      <input
        type="file"
        id="pdf"
        name="pdf"
        class="border rounded p-2 w-full"
        accept="application/pdf"
        @change="handleFileUpload"
      />
      <span class="text-sky-500 text-xs">
        Зөвхөн pdf өргөтгөлтэй файл оруулна уу.
      </span>
      <div v-if="previousPdf" class="mt-3 text-sm">
        <button
          @click="selectPreviousPdf(previousPdf)"
          :class="
            form.pdf === previousPdf
              ? 'text-sky-500'
              : 'text-gray-300 hover:text-sky-500'
          "
        >
          Одоогийн PDF:
          {{ previousPdf }}
        </button>
      </div>
    </div>
    <label for="pdf" class="font-bold">Файл /англиар/:</label>
    <div>
      <input
        type="file"
        id="pdf"
        name="pdf"
        class="border rounded p-2 w-full"
        accept="application/pdf"
        @change="handleEnFileUpload"
      />
      <span class="text-sky-500 text-xs">
        Зөвхөн pdf өргөтгөлтэй файл оруулна уу.
      </span>
      <div v-if="previousPdf_en" class="mt-3 text-sm">
        <button
          @click="selectPreviousEnPdf(previousPdf)"
          :class="
            form.pdf_en === previousPdf_en
              ? 'text-sky-500'
              : 'text-gray-300 hover:text-sky-500'
          "
        >
          Одоогийн англи PDF:
          {{ previousPdf_en }}
        </button>
      </div>
    </div>

    <div class="flex justify-center mt-5">
      <button
        v-if="loading"
        class="flex justify-center items-center gap-1 w-[10rem] bg-gray-100 text-black rounded py-2"
      >
        Уншиж байна...
      </button>
      <button
        v-else
        @click="uploadReport()"
        class="flex justify-center items-center gap-1 w-[10rem] text-white rounded py-2"
        :class="
          form.id
            ? 'bg-blue-500 hover:bg-blue-600'
            : 'bg-[#28a745] hover:bg-[#208537]'
        "
      >
        <font-awesome-icon
          :icon="form.id ? 'fa-solid fa-pen' : 'fa-solid fa-plus'"
        />
        {{ form.id ? "Хадгалах" : "Нэмэх" }}
      </button>
    </div>
  </main>

  <SuccessModal v-if="success" :success="success" />
  <ErrorModal v-if="error" :error="error" />
</template>

<script>
import adminInstance from "@/lib/adminInstance";
import { onMounted, ref } from "vue";
import SuccessModal from "@/components/ui/SuccessModal.vue";
import ErrorModal from "@/components/ui/ErrorModal.vue";

export default {
  name: "MMEditReport",
  props: {
    data: Object,
  },
  components: {
    SuccessModal,
    ErrorModal,
  },
  emits: ["fetchData"],
  setup(props, { emit }) {
    const success = ref(null);
    const error = ref(null);
    const loading = ref(false);

    const form = ref({
      id: null,
      title: null,
      title_en: null,
      pdf: null,
      pdf_en: null,
    });

    const previousImage = ref(null);
    const previousPdf = ref(null);
    const previousPdf_en = ref(null);

    const defaultImage = require("@/assets/svg/image-not-found-icon.svg");
    const imageSrc = ref(defaultImage);
    const mainImage = ref("");

    const onImageChange = (event) => {
      const file = event.target.files[0];
      if (file) {
        imageSrc.value = URL.createObjectURL(file);
        mainImage.value = file;
      } else {
        if (props.data.image) {
          imageSrc.value = props.data.image;
          mainImage.value = props.data.image;
        } else {
          imageSrc.value = defaultImage;
          mainImage.value = null;
        }
      }
    };

    onMounted(() => {
      if (props.data) {
        form.value.id = props.data.id;
        form.value.title = props.data.title;
        form.value.title_en = props.data.title_en;
        form.value.pdf = props.data.pdf;
        imageSrc.value = props.data.image;
        mainImage.value = props.data.image;
        previousImage.value = props.data.image;
        previousPdf.value = props.data.pdf;
        previousPdf_en.value = props.data.pdf_en;
      }
    });

    const resetForm = () => {
      form.value = {
        id: null,
        title: null,
        title_en: null,
        pdf: null,
        pdf_en: null,
      };

      imageSrc.value = defaultImage;
      mainImage.value = null;

      previousImage.value = null;
      previousPdf.value = null;
      previousPdf_en.value = null;
    };

    const handleFileUpload = (event) => {
      const file = event.target.files[0];
      if (file && file.type === "application/pdf") {
        form.value.pdf = file;
      } else {
        alert("Зөвхөн PDF файл сонгоно уу.");
        form.value.pdf = null;
      }
    };
    const handleEnFileUpload = (event) => {
      const file = event.target.files[0];
      if (file && file.type === "application/pdf") {
        form.value.pdf_en = file;
      } else {
        alert("Зөвхөн PDF файл сонгоно уу.");
        form.value.pdf = null;
      }
    };

    const selectDefaultImage = (url) => {
      imageSrc.value = url;
      mainImage.value = url;
    };

    const selectPreviousPdf = (url) => {
      form.value.pdf = url;
    };

    const selectPreviousEnPdf = (url) => {
      form.value.pdf_en = url;
    };

    const isValid = () => {
      if (!form.value.title) return alert("Гарчиг оруулна уу");
      if (!mainImage.value) return alert("Зураг оруулна уу");
      if (!form.value.pdf) return alert("Тайланг оруулна уу");

      return true;
    };

    const uploadReport = async () => {
      if (!isValid()) return;

      const formData = new FormData();
      formData.append("title", form.value.title);
      formData.append("title_en", form.value.title_en);
      formData.append("image", mainImage.value || previousImage.value);
      formData.append("pdf", form.value.pdf || previousPdf.value);
      formData.append("pdf_en", form.value.pdf_en || previousPdf_en.value);
      loading.value = true;
      try {
        let res;

        if (!props.data) {
          res = await adminInstance.post("/insert/member-resource", formData);
        } else {
          formData.append("id", props.data.id);
          res = await adminInstance.post("/update/member-resource", formData);
        }

        if (res.status === 200) {
          success.value = "Амжилттай шинэчлэгдлээ.";
          resetForm();
          emit("fetchData");

          setTimeout(() => {
            success.value = null;
          }, 5000);
        }
      } catch (err) {
        error.value = "Алдаа гарлаа.";

        setTimeout(() => {
          error.value = null;
        }, 5000);
      } finally {
        loading.value = false;
      }
    };

    return {
      form,
      resetForm,
      imageSrc,
      mainImage,
      onImageChange,
      uploadReport,
      success,
      error,
      loading,
      handleFileUpload,
      selectDefaultImage,
      previousImage,
      previousPdf,
      selectPreviousPdf,
      previousPdf_en,
      handleEnFileUpload,
      selectPreviousEnPdf,
    };
  },
};
</script>
